import React from 'react';

const UserPage = () => {
    return (
        <div className="UserPage">
            <h1>welcome to the user page</h1>
        </div>
    );
};

export default UserPage;
